import {
  Box,
  SimpleGrid,
  Card,
  CardBody,
  Text,
  VStack,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { MdGavel, MdCheckCircle, MdPending, MdAttachMoney, MdTrendingUp, MdSecurity } from 'react-icons/md';
import { MultaPolicia } from '../../services/policiaMunicipalApi';

interface EstadisticasMultasProps {
  multas: MultaPolicia[];
}

export default function EstadisticasMultas({ multas }: EstadisticasMultasProps) {
  
  // Calcular estadísticas
  const total = multas.length;
  const porCalificar = multas.filter(m => !m.calificado).length;
  const calificadas = multas.filter(m => m.calificado).length;
  const pagadas = multas.filter(m => m.estatus?.toLowerCase() === 'pagado').length;
  const pendientes = multas.filter(m => m.estatus?.toLowerCase() === 'pendiente').length;
  const montoTotal = multas.reduce((sum, m) => sum + (Number(m.monto) || 0), 0);
  const porcentajePagado = total > 0 ? (pagadas / total) * 100 : 0;

  return (
    <Box mb={6}>
      {/* Tarjetas de estadísticas principales */}
      <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={4}>
        <Card bg="gradient(135deg, #5b182b 0%, #691f30 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdGavel} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="2xl" fontWeight="bold">{total}</Text>
                <Text fontSize="sm">Total Infracciones</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>

        <Card bg="gradient(135deg, #dc2626 0%, #b91c1c 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdPending} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="2xl" fontWeight="bold">{porCalificar}</Text>
                <Text fontSize="sm" >Por Calificar</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>

        <Card bg="gradient(135deg, #bb8c52 0%, #a67c47 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdCheckCircle} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="2xl" fontWeight="bold">{calificadas}</Text>
                <Text fontSize="sm" >Calificadas</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>

        <Card bg="gradient(135deg, #2d5a27 0%, #3d7c47 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdAttachMoney} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="xl" fontWeight="bold">${montoTotal.toFixed(0)}</Text>
                <Text fontSize="sm" >Monto Total</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>

        <Card bg="gradient(135deg, #1a365d 0%, #2c5282 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdTrendingUp} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="xl" fontWeight="bold">{porcentajePagado.toFixed(1)}%</Text>
                <Text fontSize="sm" >% Pagadas</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>

        <Card bg="gradient(135deg, #7c2d12 0%, #9a3412 100%)">
          <CardBody>
            <HStack>
              <Icon as={MdSecurity} boxSize={8} />
              <VStack align="start" spacing={0}>
                <Text fontSize="xl" fontWeight="bold">{pendientes}</Text>
                <Text fontSize="sm">Pendientes</Text>
              </VStack>
            </HStack>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
}